import React from "react";
import "./Section1.css";
import Section1Image from "../../../../../assets/images/payrollsrsec1-img1.png";
import Section1Dots from "../../../../../assets/images/aboutus-dots.png";
const Section1 = () => {
  return (
    <div className="payrollsrsrc1_section">
      <img src={Section1Dots} alt="" className="payrollsrsrc1__section_dots" />
      <div className="payrollsrsrc1__section_left">
        <img
          src={Section1Image}
          alt=""
          className="payrollsrsrc1__section_img"
        />
      </div>
      <div className="payrollsrsrc1__section_right">
        <div className="payrollsrsrc1__secleft_description">
          <p>
            As a business grows, it must hire more employees to handle more
            operations and be productive This can result in increased payroll
            administration. We at Serene Tax can assist you in implementing the
            controls necessary to ensure a reliable, efficient, and effective
            payroll system. Our firm can also help you develop a payroll system
            and prepare all necessary payroll tax returns in a timely manner.
          </p>
          <p>
            Our practical experience in handling cases of payroll increase which
            would need to be structured and monitored with use of deep root
            technology and our team’s expertise. As your payroll expert, it
            would also prove to be beneficial that your team can focus on using
            their skills for your organization more productively. With our help
            in payroll services you can help reduce the time spent on
            administration through developing and implementing a computerized
            payroll system that will facilitate processing, timely payment and
            preparation of tax returns. We prepare all federal and state returns
            with electronic filing capabilities
          </p>
        </div>
      </div>
    </div>
  );
};

export default Section1;
